import { logger } from '@sendpayments/js-utils';

export const reduce = () => {
  logger.log('@sendpayments/react-shared/remote-data', `reducer/EMPTY_CONTEXT, context emptied`);

  return {};
};
